import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["formatAssetsUrl", "options", "optionTextStyles", "searchInputTextStyles", "placeholder", "onChange", "onClose", "showDialingCode"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, Flex, Image, Input, List, ListItem, Text, useTheme } from '@chakra-ui/react';
import { getInputTypographyOverride } from '@whitbread-eos/utils';
import { memo, useCallback, useEffect, useRef, useState } from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function CountriesList(_ref) {
  var formatAssetsUrl = _ref.formatAssetsUrl,
    options = _ref.options,
    optionTextStyles = _ref.optionTextStyles,
    searchInputTextStyles = _ref.searchInputTextStyles,
    placeholder = _ref.placeholder,
    onChange = _ref.onChange,
    onClose = _ref.onClose,
    _ref$showDialingCode = _ref.showDialingCode,
    showDialingCode = _ref$showDialingCode === void 0 ? true : _ref$showDialingCode,
    rest = _objectWithoutProperties(_ref, _excluded);
  var theme = useTheme();
  var searchInputTypographyOverride = getInputTypographyOverride(searchInputTextStyles, theme === null || theme === void 0 ? void 0 : theme.textStyles);
  var _useState = useState(options),
    _useState2 = _slicedToArray(_useState, 2),
    filteredList = _useState2[0],
    setFilteredList = _useState2[1];
  var _useState3 = useState(-1),
    _useState4 = _slicedToArray(_useState3, 2),
    focusedIndex = _useState4[0],
    setFocusedIndex = _useState4[1];
  var containerRef = useRef(null);
  var searchInputRef = useRef(null);
  var itemRefs = useRef([]);
  var handleSearch = useCallback(event => {
    var value = event.target.value.toLowerCase();
    var result = (options === null || options === void 0 ? void 0 : options.filter(item => {
      return item.countryName.toLowerCase().includes(value) || item.dialingCode.toLowerCase().includes(value);
    })) || [];
    setFilteredList(result);
    setFocusedIndex(-1);
  }, [options]);
  var handleListKeyDown = useCallback(event => {
    if (filteredList.length === 0) return;
    if (event.key === 'ArrowDown') {
      event.preventDefault();
      setFocusedIndex(prev => prev < filteredList.length - 1 ? prev + 1 : 0);
    } else if (event.key === 'ArrowUp') {
      event.preventDefault();
      setFocusedIndex(prev => prev > 0 ? prev - 1 : filteredList.length - 1);
    } else if (event.key === 'Enter' && focusedIndex >= 0) {
      event.preventDefault();
      onChange(filteredList[focusedIndex]);
    } else if (event.key === 'Escape' && onClose) {
      event.preventDefault();
      onClose();
    }
  }, [filteredList, focusedIndex, onChange, onClose]);
  var handleListFocus = useCallback(() => {
    if (focusedIndex === -1 && filteredList.length > 0) {
      setFocusedIndex(0);
    }
  }, [focusedIndex, filteredList.length]);
  useEffect(() => {
    var _searchInputRef$curre;
    (_searchInputRef$curre = searchInputRef.current) === null || _searchInputRef$curre === void 0 || _searchInputRef$curre.focus();
    if (options.length > 0) {
      setFocusedIndex(0);
    }
  }, [options.length]);
  useEffect(() => {
    var _itemRefs$current;
    if (focusedIndex >= 0 && itemRefs !== null && itemRefs !== void 0 && (_itemRefs$current = itemRefs.current) !== null && _itemRefs$current !== void 0 && _itemRefs$current[focusedIndex]) {
      var element = itemRefs.current[focusedIndex];
      if (element && typeof element.scrollIntoView === 'function') {
        if (focusedIndex === 0 && containerRef.current) {
          containerRef.current.scrollTop = 0;
        } else {
          element.scrollIntoView({
            block: 'nearest'
          });
        }
      }
    }
  }, [focusedIndex]);
  return _jsxs(Box, _objectSpread(_objectSpread(_objectSpread({
    ref: containerRef
  }, containerStyle), rest), {}, {
    children: [_jsx(Box, _objectSpread(_objectSpread({}, searchContainerStyle), {}, {
      children: _jsx(Input, _objectSpread(_objectSpread(_objectSpread(_objectSpread({
        ref: searchInputRef,
        autoComplete: "off",
        isInvalid: false,
        placeholder: placeholder
      }, searchInputStyle), searchInputTextStyles), searchInputTypographyOverride), {}, {
        onChange: handleSearch,
        onKeyDown: handleListKeyDown
      }))
    })), _jsx(List, {
      role: "listbox",
      "aria-activedescendant": focusedIndex >= 0 && filteredList[focusedIndex] ? "country-option-".concat(filteredList[focusedIndex].countryCode) : undefined,
      onKeyDown: handleListKeyDown,
      onFocus: handleListFocus,
      tabIndex: 0,
      children: filteredList === null || filteredList === void 0 ? void 0 : filteredList.map((item, index) => _jsx(ListItem, _objectSpread(_objectSpread(_objectSpread({
        id: "country-option-".concat(item.countryCode),
        ref: el => itemRefs.current[index] = el,
        role: "option",
        "aria-selected": focusedIndex === index
      }, listItemStyle), focusedIndex === index ? {
        bg: 'lightGrey5'
      } : {}), {}, {
        onClick: () => {
          onChange(item);
        },
        onMouseEnter: () => setFocusedIndex(index),
        children: _jsxs(Flex, {
          children: [_jsx(Image, {
            borderRadius: "full",
            boxSize: "1.5rem",
            src: formatAssetsUrl(item.flagSrc),
            title: item.countryName,
            alt: item.countryName,
            mr: 'sm'
          }), showDialingCode && item.dialingCode && _jsx(Text, _objectSpread(_objectSpread({
            as: "span",
            mr: 3,
            className: "countryDialingCode"
          }, optionTextStyles), {}, {
            children: item.dialingCode
          })), _jsx(Text, _objectSpread(_objectSpread({
            as: "span"
          }, optionTextStyles), {}, {
            children: item.countryName
          }))]
        })
      }), "".concat(item.countryCode, "-").concat(item.countryName)))
    })]
  }));
}
var containerStyle = {
  bg: 'white',
  borderRadius: 'lg',
  boxShadow: '0px 1px 30px rgba(0, 0, 0, 0.1)',
  height: 'auto',
  maxH: 'xs',
  my: 1,
  overflow: 'auto',
  position: 'absolute',
  width: 'full',
  zIndex: 999
};
var listItemStyle = {
  cursor: 'pointer',
  px: 4,
  py: 3,
  _hover: {
    bg: 'lightGrey5'
  }
};
var searchContainerStyle = {
  bg: 'white',
  p: 4,
  position: 'sticky',
  top: 0,
  zIndex: 1
};
var searchInputStyle = {
  borderRadius: 'md',
  size: 'md',
  _focusWithin: {
    borderColor: 'primary'
  }
};
export default memo(CountriesList);